import React from "react";

import { Grid, Link, SvgIcon } from "@mui/material";
import TwitterIcon from "@mui/icons-material/Twitter";
import { LinkedIn } from "@mui/icons-material";

const styles = {
  icon: {
    color: "#979797",
    fontSize: { xs: 18, sm: 20, md: 24, lg: 28, xl: 32 },
    pt: { xs: 0.5, sm: 1, md: 1, lg: 1.5, xl: 2 },
    pr: { xs: 0.5, sm: 3, md: 3, lg: 3, xl: 4 },
    ":hover": {
      color: "#eeeeee",
    },
  },
};
const FooterLogos = () => {
  return (
    <Grid
      container
      direction="row"
      justifyContent="start"
      sx={{ p: 0, width: "100%" }}
    >
      <Link
        target="_blank"
        rel="noreferrer"
        href="https://artistiggostudio.artstation.com/"
      >
        <SvgIcon viewBox="0 0 42 32" sx={styles.icon}>
          <path d="M35 24.354c0-.704-.208-1.36-.565-1.91L22.937 2.525A3.536 3.536 0 0 0 19.813.652h-6.077l17.76 30.666 2.8-4.833c.553-.925.704-1.334.704-2.131Zm-35-.037 2.956 5.093h.001a3.536 3.536 0 0 0 3.157 1.938h19.624l-4.072-7.03H0ZM10.832 5.621l7.938 13.701H2.893l7.939-13.701Z" />
        </SvgIcon>
      </Link>

      <Link
        target="_blank"
        rel="noreferrer"
        href="https://www.linkedin.com/company/artistiggostudio/"
      >
        <LinkedIn sx={styles.icon} color={styles.icon.color} />
      </Link>
      <Link
        target="_blank"
        rel="noreferrer"
        href="https://twitter.com/artistiggo"
      >
        <TwitterIcon sx={styles.icon} color={styles.icon.color} />
      </Link>
    </Grid>
  );
};

export default FooterLogos;
